
import { franceData } from './france';
import { franceExpanded2 } from './franceExpansion2';
import { germanyData } from './germany';
import { italyData } from './italy';
import { spainData } from './spain';
import { unitedKingdomData } from './unitedKingdom';
import { unitedKingdomExpanded2 } from './ukExpansion2';
import { russiaData } from './russia';
import { netherlandsData } from './netherlands';
import { greeceData } from './greece';
import { portugalData } from './portugal';
import { finalEuropeCountries } from './finalEuropeCountries';
import { finalEuropeCountries2 } from './finalEuropeCountries2';
import { finalEuropeCountries3 } from './finalEuropeCountries3';
import { finalEuropeCountries4 } from './finalEuropeCountries4';
import { finalEuropeCountries5 } from './finalEuropeCountries5';
import { finalEuropeCountries6 } from './finalEuropeCountries6';
import { finalEuropeCountries7 } from './finalEuropeCountries7';
import { nordicCountriesExpanded } from './nordicExpansion';
import { finalEuropeCountries8 } from './finalEuropeCountries8';
import { finalEuropeCountries9 } from './finalEuropeCountries9';
import { finalEuropeCountries10 } from './finalEuropeCountries10';
import { finalEuropeCountries11 } from './finalEuropeCountries11';
import { phase13ExpansionCountries } from '../expansions/phase13Expansion';
import { WorldCountry } from '../types';

// Get expanded countries from Phase 13, ensuring proper typing
const expandedCountriesFromPhase13 = phase13ExpansionCountries.filter((country: WorldCountry) => 
  ['france', 'germany', 'italy', 'spain', 'poland'].includes(country.slug)
);

// Build the final europe countries array with proper typing
const baseEuropeCountries: WorldCountry[] = [
  unitedKingdomExpanded2, // Reemplaza unitedKingdomData con versión expandida
  russiaData,
  netherlandsData, // Ahora expandido a 100 ciudades
  greeceData,
  portugalData,
  ...finalEuropeCountries,
  ...finalEuropeCountries2,
  ...finalEuropeCountries3,
  ...finalEuropeCountries4,
  ...finalEuropeCountries5, // Finlandia y Dinamarca expandidos
  ...finalEuropeCountries6, // República Checa, Hungría y Polonia expandidos
  ...finalEuropeCountries7, // Polonia, Rumania, Bulgaria y Croacia expandidos
  ...nordicCountriesExpanded, // Suecia y Noruega expandidos
  ...finalEuropeCountries8, // Portugal expandido
  ...finalEuropeCountries9, // Eslovaquia expandida
  ...finalEuropeCountries10, // Bélgica expandida - Fase 10
  ...finalEuropeCountries11  // Estonia, Letonia y Moldavia expandidas - Fase 12
];

// Combine with expanded countries, avoiding duplicates
export const europeCountries: WorldCountry[] = [
  ...expandedCountriesFromPhase13,
  ...baseEuropeCountries.filter(country => 
    !expandedCountriesFromPhase13.some(expanded => expanded.slug === country.slug)
  )
];
